
export const ApiEndpoints = {
  // Base URLs
  QA: "https://qa-clientvalidation.cashe.co.in",
  PROD: "https://clientvalidation.cashe.co.in",
  STAGE: "https://qa-apigateway.cashe.co.in",

  mockApi1: "https://4d32b4ce-e513-43de-87d2-50c7b23cb2c2.mock.pstmn.io",
  mockApi2: "https://8b347ade-6803-443f-88b6-794af881118f.mock.pstmn.io",
  mockApi3: "https://299684da-4211-453a-90a1-6f13ccbaacbd.mock.pstmn.io",

  mainHost: "qa-collectiondashboard.cashe.co.in",
  // backend base url
  qaBaseUrl: "https://qa-api.bookyourzone.com",
  localUrl: "http://localhost:9000",
  prodBaseUrl: "https://prod-api.bookyourzone.com",
  stageBaseUrl: "https://qa-api.bookyourzone.com",


  //user
  login: "/api/users/login",
  verifyOtp:"/api/users/verifyOtp",
  // path specific url
  venuesList: "/api/venue/getAllRegisterVenue",
  getVenueDetails: "/api/venue/getVenueDetails",
  getProfile: "/api/users/getProfile",
  updateUserProfile: "/api/users/updateUserProfile",
  getStaticPlatformFeeConfig: "/api/static-config/getStaticPlatformFeeConfig",
  getCategories: "/api/static-config/getCategories",
  createBooking: "/api/booking/createBooking",
  DBLcreateBooking: "/api/booking/direct-booking/createBooking",  // pass subscriptionId as /:subscriptionId

  cancelBooking: "/api/bookingPayment/cancelBooking",
  initPaymentForPendingBooking:"/api/booking/initPaymentForPendingBooking",
  cancelPendingBooking: "/api/bookingPayment/cancelPendingBooking",
  getMyBookings: "/api/booking/getMyBookings",
  getmyBookingsWithPagination:"/api/booking/getMyBookingsWithPagination",
  getUserPendingBookings: "/api/booking/getUserPendingBookings",
  verifyPayment: "/api/bookingPayment/verifyPayment",
  getNearbyVenues: "/api/venue/nearby",
  writeReview: "/api/review/writeVenueReview",
  getAllReviews: "/api/review/getAllReviews",
  filterVenues:"/api/venue/filterVenues",
  getWebsiteBySubdomain:"/api/vendorWebsite/getWebsiteBySubdomain",
  getVendorRegisterVenues:"/api/venue/getVendorRegisterVenues",
  getSlotsByDate:"/api/users/venue/getSlotsByDate",
  wishlist:"/api/user/wishlist/toggle",
  validateBookingLink:"api/bookinglink/validateBookingLink",
  validateDirectBookingLink:"/api/bookinglink/validateDirectBookingLink" ,// pass /venueSlug/Bookingid
  getDirectBookingLinkVenueSlotsByDate:"/api/bookinglink/getDirectBookingLinkVenueSlotsByDate" ,// pass /venueSlug/Bookingid
  getPlatformOffers:"/api/pricing/getPlatformOffers",
  getDBLPlatformOffers:"/api/pricing/direct-booking/getDBLPlatformOffers",  // pass subscriptionId as /:subscriptionId
  previewBookingPriceAferCouponApplied:"/api/booking/previewBookingPriceAferCouponApplied",
  previewDBLBookingPriceAferCouponApplied:"/api/booking/direct-booking/previewDBLBookingPriceAferCouponApplied",// pass subscriptionId as /:subscriptionId
  getUsersRecommendedVenues:"/api/recommendation/getUsersRecommendedVenues",
  checkVenueAvailability:"/api/venue/checkVenueAvailability",// pass lat ,lng,or city
  getTrendingVenues:"/api/venue/getTrendingVenues" ,// pass lat ,lng,or city
  getVenuePricingRule:"/api/venue/getVenuePricingRule",
  getTrendingSports:"/api/dashboard/getTrendingSports",
  getMyBookingDetailsById: "/api/booking/getMyBookingDetailsById",
  rescheduleBooking:  "/api/booking/rescheduleBooking",
  getGlobalPlatformOffers:"/api/pricing/getGlobalPlatformOffers",
  searchLocation:"/api/venue/searchLocation", // typeahead: { query, limit, country, lat, lng }
};
